export const SEARCH_PRODUCT_BY_BATCH_START = 'SEARCH_PRODUCT_BY_BATCH'
export const SEARCH_PRODUCT_BY_BATCH_SUCCESS = 'SEARCH_PRODUCT_BY_BATCH_SUCCESS'
export const SEARCH_PRODUCT_BY_BATCH_ERROR = 'SEARCH_PRODUCT_BY_BATCH_ERROR'
export const REJECT_PRODUCT_BY_BATCH_START = 'REJECT_PRODUCT_BY_BATCH_START'
export const REJECT_PRODUCT_BY_BATCH_SUCCESS = 'REJECT_PRODUCT_BY_BATCH_SUCCESS'
export const REJECT_PRODUCT_BY_BATCH_ERROR = 'REJECT_PRODUCT_BY_BATCH_ERROR'
export const RESET_REJECT_STORE = 'RESET_REJECT_STORE'
